<script lang="ts">
	// src/routes/(app)/(platform)/(videos)/videos/+layout.svelte
	import { page } from '$app/stores';
	import Pagination from '$lib/components/platform/Pagination.svelte';
	import Breadcrumbs from '$lib/components/platform/Breadcrumbs.svelte';

	let oldLinks = [
		{ text: 'Home', href: '/' },
		{ text: 'Videos', href: '/videos' }
	];
	let links = [...oldLinks];

	$: if ($page.data.sector) {
		links = [
			...oldLinks,
			{ text: $page.data.sector.name, href: `/videos/sector/${$page.data.sector.slug}` }
		];
	} else {
		links = [...oldLinks];
	}

	$: if ($page.url.pathname.split('/').includes('free')) {
		links = [...links, { text: 'free', href: `/videos/free` }];
	}

	$: if ($page.url.pathname.split('/').includes('promotional')) {
		links = [...links, { text: 'promotional', href: `/videos/promotional` }];
	}

	$: if ($page.url.pathname.split('/').includes('latest')) {
		links = [...links, { text: 'latest', href: `/videos/latest` }];
	}
</script>

<div class="h-20 bg-secondary-400 md:h-0">&nbsp;</div>

<Breadcrumbs {links}></Breadcrumbs>

<div class="bg-white">
	<div class="mx-auto max-w-screen-2xl px-2 py-16 md:px-16 md:px-8">
		<slot />
	</div>
</div>

{#await $page.data.videos then videos}
	{#if videos.count > 0}
		<div class="bg-secondary-100">
			<Pagination total={videos.count} pageSize={24}></Pagination>
		</div>
	{/if}
{/await}
